/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DataVaxiomPersonTitleValue from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleValue/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/SimilarPatients/Content/Content/SimilarPerson/Person/Details/Content/Title"
  
}) {
let similarPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'title',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Title.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Title"
 weight="semibold"
/>
<DataVaxiomPersonTitleValue
  viewPath={`${viewPath}/DataVaxiomPersonTitleValue`}
 marginTop={dtSpaceXxs}
 marginBottom={dtSpaceXxs}
 data="similar_person.title"
 value={similarPersonTitleValueData}
/>
</div>
{children}
</React.Fragment>)
}